import { NgModule } from "@angular/core";
import { SafeHtmlTextPipe } from "./safe-html-text/SafeHtmlText.pipe";
import { KeysPipe } from "./keys/keys.pipe";
import { GetByIdPipe } from "./get-by-id/getById.pipe";
import { HtmlToPlaintextPipe } from "./html-to-plain-text/htmlToPlaintext.pipe";
import { FilterPipe } from "./filter/filter.pipe";
import { CamelCaseToDashPipe } from "./camel-case-to-dash/camelCaseToDash.pipe";
import { SafeUrlPipe } from "./safe-url/safeUrl.pipe";
import { FormatSizeStrPipe } from "./format-size/formatSize.pipe";

@NgModule({
    declarations: [
        SafeHtmlTextPipe,
        KeysPipe,
        GetByIdPipe,
        HtmlToPlaintextPipe,
        FilterPipe,
        CamelCaseToDashPipe,
        SafeUrlPipe,
        FormatSizeStrPipe,
    ],
    imports: [],
    exports: [
        SafeHtmlTextPipe,
        KeysPipe,
        GetByIdPipe,
        HtmlToPlaintextPipe,
        FilterPipe,
        CamelCaseToDashPipe,
        SafeUrlPipe,
        FormatSizeStrPipe,
    ],
})
export class FusePipesModule {}
